export default {
    name: 'reportsInventory',
    component: () => import(/* webpackChunkName: "reports-inventory-Layout" */ '@/modules/reports/inventories/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.reports.inventory.index',
            component: () => import(/* webpackChunkName: "reports-inventory-index" */ '@/modules/reports/inventories/views/Index'),
        },
    ]
}